<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
  <br />
  <div class="row">
    <div class="col-8 mb-3">
      <h2 class="title-list">List of Plans</h2>
    </div>

    <div class="col-4 text-end" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
      <div>
        <button appTooltip="Show Archived the Plans" class="btn btn-secondary" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)">
          <i class="bi bi-archive"></i>
        </button>
      </div>

      <div>
        <button [appTooltip]="'Export to Excel the Plans'"  *ngIf="permissionsService.editPermission && permissionsService.readPermission" class="btn btn-secondary"
          (click)="exportPlansListToExcel()">
          <i class="bi bi-file-earmark-excel"></i>
        </button>
      </div>

      <div *ngIf="permissionsService.createPermission">
        <button (click)="showFormCreate()" class="btn btn-primary">
          Create Plan
        </button>
      </div>

    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <app-table-control 
        [columns]="columns" 
        [data]="plans" [pageSize]="10"  
        (actionClick)="onAction($event)"  
        [actionButtons]="actionButtons" 
        [showActions]="true"></app-table-control>


    
    </div>
  </div>

 

  <!-- Modal -->
  <div class="modal fade" id="modalSwitch" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">
            Customer Active/Inactive
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  (click)="updatePlanStatus(false)">
          </button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this plan?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updatePlanStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlanStatus(true)">
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">Plan {{isFilteredByStatus ? 'Restore' : 'Archive'}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  (click)="updatePlanStatus(false)">
          </button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this plan?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updatePlanStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlanStatus(true)">
              Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>